<template lang="pug">
aside
  LabelledValue(label="Issue" :value="page.issue.name")
  LabelledValue(label="Slug" :value="page.slug")
  LabelledEditableValue(label="Notes" v-model="notes" :multi-line="true" @blur="save")
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mapStores } from 'pinia'
  import { usePageStore } from '@/stores/page'
  import LabelledValue from '@/components/shared/labelled_value.vue'
  import LabelledEditableValue from '@/components/shared/labelled_editable_value.vue'

  export default {
    components: {
      LabelledValue,
      LabelledEditableValue
    },

    computed: {
      ...mapStores(usePageStore),
      page() { return this.pageStore.page },
      notes: {
        get() { return this.pageStore.page.notes },
        set(v) { this.pageStore.page.notes = v }
      }
    },

    methods: {
      save() {
        this.pageStore.update()
      }
    }
  }
</script>
